import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['a-scene', 'a-box','a-entity', 'a-icosahedron', 'a-torus', 'a-sphere']

new Vue({
  render: h => h(App),
}).$mount('#app')
